var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "filters" },
      [
        _c(
          "div",
          { staticClass: "filter" },
          _vm._l(_vm.filtersItems, function(item, index) {
            return _c(
              "el-radio",
              {
                key: index,
                attrs: { label: index },
                model: {
                  value: _vm.radioCurrent,
                  callback: function($$v) {
                    _vm.radioCurrent = $$v
                  },
                  expression: "radioCurrent"
                }
              },
              [_vm._v(_vm._s(item.name))]
            )
          }),
          1
        ),
        _vm._v(" "),
        _c("tags-input", {
          staticClass: "common-tags",
          attrs: {
            message: _vm.$t("language.inputTab.filterMessage"),
            type: "filter"
          },
          model: {
            value: _vm.items,
            callback: function($$v) {
              _vm.items = $$v
            },
            expression: "items"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-366e2ce3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-366e2ce3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_transfer_options/tab_filter.vue
// module id = null
// module chunks = 